import { api } from '../api';
import type {
  AeropayBankConnection,
  AeropayUser,
  BankAccountId,
  BankAccountResponse,
  CreateAeropayUser,
  LinkBankAccountProps,
} from './aeropay.types';

export interface FetchAeropayUserProps {
  jwt?: string | null;
}

export interface FetchAeropayBankConnectionProps {
  aggregator?: string;
  jwt?: string | null;
}

interface CreateAeropayUserProps {
  data: CreateAeropayUser;
  jwt?: string | null;
}

interface ConfirmJaneGoldUserProps {
  jwt?: string | null;
}

interface LinkAeropayBankAccountProps {
  data: LinkBankAccountProps;
  jwt?: string | null;
}

interface SelectAeropayBankAccountProps {
  data: BankAccountId;
  jwt?: string | null;
}

interface DeleteAeropayBankAccountProps {
  data: BankAccountId;
  jwt?: string | null;
}

const BASE_URL = '/v1/users/aeropay_accounts';

export const aeropayUrls = {
  aeropayAccounts: () => BASE_URL,
  bankConnection: ({ aggregator }: { aggregator?: string } = {}) =>
    aggregator
      ? `${BASE_URL}/bank_connection?aggregator=${aggregator}`
      : `${BASE_URL}/bank_connection`,
  selectBankAccount: () => `${BASE_URL}/select_bank_account`,
  deleteBankAccount: ({ bankAccountId }: BankAccountId) =>
    `${BASE_URL}/delete_bank_account?bank_account_id=${bankAccountId}`,
};

export const fetchAeropayUser = async ({ jwt }: FetchAeropayUserProps) => {
  if (!jwt) return null;

  return api.get<AeropayUser>(aeropayUrls.aeropayAccounts(), jwt);
};

export const fetchAeropayBankConnection = async ({
  aggregator = 'aerosync',
  jwt,
}: FetchAeropayBankConnectionProps) =>
  api.get<AeropayBankConnection>(
    aeropayUrls.bankConnection({ aggregator }),
    jwt
  );

export const createAeropayUser = async ({
  data,
  jwt,
}: CreateAeropayUserProps) =>
  api.post<AeropayUser>(aeropayUrls.aeropayAccounts(), data, jwt);

export const confirmJaneGoldUser = async ({ jwt }: ConfirmJaneGoldUserProps) =>
  api.patch(
    aeropayUrls.aeropayAccounts(),
    { requires_gold_confirmation: false },
    jwt
  );

export const linkAeropayBankAccount = async ({
  data,
  jwt,
}: LinkAeropayBankAccountProps) =>
  api.post<BankAccountResponse>(
    aeropayUrls.bankConnection(),
    {
      user_id: data.aeropayUserId,
      user_password: data.aeropayUserPassword,
    },
    jwt
  );

export const selectAeropayBankAccount = async ({
  data,
  jwt,
}: SelectAeropayBankAccountProps) =>
  api.post<BankAccountResponse>(
    aeropayUrls.selectBankAccount(),
    { bank_account_id: data.bankAccountId },
    jwt
  );

export const deleteAeropayBankAccount = async ({
  data,
  jwt,
}: DeleteAeropayBankAccountProps) =>
  api.delete<BankAccountResponse>(
    aeropayUrls.deleteBankAccount({ bankAccountId: data.bankAccountId }),
    jwt
  );
